module.exports = __webpack_public_path__ + "static/media/3s_bis_03.38033b04.png";